/**
 * Connection Node API
 * Handles distributed WebSocket connection assignment
 */
import api from './client';

export interface ConnectionSessionResponse {
  session_id: string;
  host: string;
  token: string;
  expires_at: string;
  region: string;
}

export interface ConnectionSessionRequest {
  device_id?: string;
  preferred_region?: string;
}

/**
 * Request a connection session from the API
 *
 * The API will:
 * 1. Select an appropriate connection node (based on region, load, health)
 * 2. Generate a JWT token for WebSocket authentication
 * 3. Return the node hostname and token
 */
export const connectionApi = {
  /**
   * Request a new connection session
   */
  async requestSession(data?: ConnectionSessionRequest): Promise<{ data: ConnectionSessionResponse }> {
    return api.post('/connection-nodes/session', data || {});
  },
};
